import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class LangInterceptor implements HttpInterceptor {
    constructor(private translate: TranslateService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let lang = localStorage.getItem('lang');
        if (lang == null) {
            lang = 'FR';
        }
        request = request.clone({
            setHeaders: {
                'X-LANG': lang
            }
        });
        return next.handle(request);
    }
}
